import { resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "goods-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_draggable = _resolveComponent("draggable");
    const _component_el_cascader = _resolveComponent("el-cascader");
    const _component_Goods = _resolveComponent("Goods");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_draggable, {
                class: "list-group",
                group: {
                    name: 'imageList',
                    pull: false,
                    put: false
                },
                "item-key": "id",
                modelValue: $data.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.value = $event),
                animation: 340
            }, {
                item: _withCtx(({ element, index })=>[
                        ..._cache[3] || (_cache[3] = [])
                    ]),
                _: 1
            }, 8, [
                "modelValue"
            ]),
            _createVNode(_component_el_cascader, {
                modelValue: $data.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.value = $event),
                options: _ctx.options,
                props: _ctx.props,
                onChange: _ctx.handleChange
            }, null, 8, [
                "modelValue",
                "options",
                "props",
                "onChange"
            ])
        ]),
        $data.dialog.save ? (_openBlock(), _createBlock(_component_Goods, {
            key: 0,
            ref: "GoodsDialog",
            onSuccess: $options.handleSuccess,
            onClosed: _cache[2] || (_cache[2] = ($event)=>$data.dialog.save = false)
        }, null, 8, [
            "onSuccess"
        ])) : _createCommentVNode("", true)
    ], 64);
}
